import React from "react";
const PlusSvg = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 8C16 8.55267 15.6419 9.00047 15.1998 9.00047H8.99953V15.2008C8.99953 15.6419 8.55172 16 8 16C7.44733 16 6.99953 15.6419 6.99953 15.2008V9.00047H0.799244C0.358054 9.00047 0 8.55267 0 8C0 7.44828 0.358054 7.00047 0.799244 7.00047H6.99953V0.800189C6.99953 0.358054 7.44733 0 8 0C8.55172 0 8.99953 0.358054 8.99953 0.800189V7.00047H15.1998C15.6419 7.00047 16 7.44828 16 8Z"
      />
    </svg>
  );
};

export default PlusSvg;
